module.exports = __webpack_public_path__ + "static/fonts/roboto-v18-latin-700-376e0950b361fbd3b09508031f498de5.eot";